import angular from 'angular';
import moment from 'moment';

class routingCodeCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $rootScope,
        logger,
        $uibModal,
        AuthSvc,
        PrincipalSvc,
        RoutingCodeSvc,
        RoutingCode
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.authSvc = AuthSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.RoutingCodeSvc = RoutingCodeSvc;
        this.RoutingCode = RoutingCode;
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.TIME_MASK = {h:0, m:0, s:0, ms:0};
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html'),
        };
        this.deleteEnabled = false;
        this.todayDate = moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK);
        this.principal = angular.copy(this.resolve.principal);
        this.legalEntity = angular.copy(this.resolve.legalEntity);
        this.subEntity = angular.copy(this.resolve.subEntity);
        this.routingCodeDto = angular.copy(this.resolve.routingCode);
        this.initialRoutingCode = angular.copy(this.resolve.routingCode);
        this.update = angular.copy(this.resolve.update);
        this.statusPpfSend = this.statusPpfSend();

        if (this.update) {
            this.status = this.routingCodeDto.status;
            this.showRoutingPdpRe = this.canEditPdpRe();
            this.processRoutingCode();

        } else {
            this.status = 'ACTIVE';
        }
    }
    statusPpfSend() {
        var status = {};
        if (this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.complianceStatus) {
            switch (this.initialRoutingCode.pdpRe.complianceStatus) {
                case 'RECEIVING_ADDRESS_PERIOD_ENCLOSES':
                case 'BAD_PARAMETER':
                case 'RECEIVING_ADDRESS_REQUEST_NOT_FOUND':
                case 'RECEIVING_ADDRESS_ALREADY_EXISTS':
                    status = { color: 'red', text: 'principal.company.not_sent_to_compliance' };
                    break;
                case 'SUCCESS':
                    status = { color: 'orange', text: 'principal.company.in_progress_to_compliance' };
                    break;
            }
        }
        return status;
    }
    processRoutingCode() {
        this.RoutingCodeSvc.getRoutingCodeDetails(this.routingCodeDto.id)
            .then(entities => {
                this.routingCodeDto = new this.RoutingCode(entities);
                this.initialRoutingCode = new this.RoutingCode(this.routingCodeDto);

                if (this.showRoutingPdpRe) {
                    this.isDatePdpReChanged = this.datePdpReChanged();
                    this.pdpReIsActive = this.isPdpReActive();
                    this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
                    this.isSentoPpf = this.isSentToPpf();
                }
            });
    }

    isEditAuthorized() {
        return this.authSvc.isEditAuthorized();
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    statusChanged() {
        if (this.update) {
            this.routingCodeDto.status = this.status;
        }
    }

    updateRouting() {
        this.setPdpBeforSave();
        if (this.form.$valid) {
            this.prepareDataBeforeSave();
            this.RoutingCodeSvc.createUpdateRouting(this.subEntity.id, this.routingCodeDto).then(
                () => {
                    if (this.update) {
                        this._onSaveSuccess('success.update');


                    } else {
                        this._onSaveSuccess('success.create');
                    }
                    var res = {
                        updated: this.update,
                        routingCodeDto: this.routingCodeDto,
                        initialRoutingCode: this.initialRoutingCode
                    };
                    this.$rootScope.$emit('routingCodeUpdated', res);
                    this.modalInstance.close(res);
                },

                error => {
                    // Echec
                    this._onSaveError(error);
                }
            );
        }
        else if (this.canShowStartDatePdPReToasterError()) {
            this.logger.error("La date de début de PDP de réception doit être supérieure ou égale à la date du jour")
        } else if (this.canShowEndDatePdPReToasterError()){
            this.logger.error("La date de fin de PDP de réception doit être supérieure ou égale à la date de début et à la date du jour")
        }

    }

    _onSaveSuccess(message) {
        this.logger.success(message, null, null, { entityName: 'Le code routage' });
    }

    _onSaveError(error) {
        if (error.status === 400 && error.data) {
            switch (error.data.code) {
                case 'START_DATE_PDP_INVALID':
                    this.logger.error('error.functional.start_date_pdp_invalid');
                    break;
                    case 'DUPLICATE_ROUTING_CODE':
                        this.logger.error('error.routing_code_used')
                    break;
                default:
                    this.logger.error('error.update', error);
                    break;
            }
        }
    }

    isPdpReActive(){
        let today =  moment(this.TIME_MASK)
        if (!this.initialRoutingCode.pdpRe || this.initialRoutingCode.pdpRe && today.isAfter(this.initialRoutingCode.pdpRe.startDate) && !today.isSame(this.initialRoutingCode.pdpRe.startDate) && this.initialRoutingCode.pdpRe.endDate && today.isAfter(this.initialRoutingCode.pdpRe.endDate) && !today.isSame(this.initialRoutingCode.pdpRe.endDate)){
            return false;
        }
        return true;
    }
    // Afficher le bloc pdp réception uniquement en mode édition pour les code routages dont le pays de la sous-entité fait partie de la France métropolitaine et outre-mer
    canEditPdpRe() {
        return this.initialRoutingCode.id != null && this.PrincipalSvc.getSocFr().includes(this.subEntity.countryCode)
            &&  this.legalEntity.principal.profilBuyer;
    }
    datePdpReChanged(){
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        this.isDatePdpReChanged = this.isStartDatePdpReChanged() || this.isEndDatePdpReChanged() ;
        return this.isDatePdpReChanged;
    }
    isStartDatePdpReChanged(){
        let startDatePdpReChanged = false
        if(this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.startDate){
            let currentStartDate = this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue ? this.formatDate(this.form.pdpStartDateRe.$viewValue) : moment(this.routingCodeDto.pdpRe.startDate);
            startDatePdpReChanged = !this.initialRoutingCode.pdpRe.startDate.isSame(currentStartDate);
        }else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue){
            startDatePdpReChanged = true
        }
        return startDatePdpReChanged;
    }
    isEndDatePdpReChanged(){
        let EndPdpReChanged = false
        if(this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.endDate){
            let currentEndDate = this.form && this.form.pdpEndDateRe && this.form.pdpEndDateRe.$viewValue ?   this.formatDate(this.form.pdpEndDateRe.$viewValue) : moment(this.routingCodeDto.pdpRe.endDate);
            EndPdpReChanged = !this.initialRoutingCode.pdpRe.endDate.isSame(currentEndDate);
        }else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue){
            EndPdpReChanged = true
        }
        return EndPdpReChanged;
    }
    isEditableStartDatePdpRe(){
        let initialStartDate = this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.startDate ?   moment(this.initialRoutingCode.pdpRe.startDate)  : null
        let initialEndDate = this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.endDate ?   moment(this.initialRoutingCode.pdpRe.endDate) : null
        if(this.pdpReIsActive){
            if(!this.initialRoutingCode.pdpRe || !this.initialRoutingCode.pdpRe.startDate || !this.routingCodeDto.pdpRe || !this.routingCodeDto.pdpRe.startDate){
                return true
            }else if (initialStartDate && initialStartDate.isAfter(this.todayDate)  && !initialStartDate.isSame(this.todayDate) ){
                return true
            }else if(this.routingCodeDto.pdpRe && this.routingCodeDto.pdpRe.endDate && initialEndDate && initialEndDate.isBefore(this.todayDate) &&  !initialEndDate.isSame(this.todayDate)){
                return true
            }
        }
        return false
    }
    /** transforme une chaine de carac en une date
     *
     * @param dateString
     */
    formatDate(dateString){
        if(dateString instanceof Date){
            return moment(dateString);
        } else if(dateString)
        {
            const dateArray = dateString.replace(/-/g, '/').split('/');
            let formatedDate =  new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
            return moment(formatedDate);
        }
    }
    activeSyPdpRe(){
        // Vérifie si la date de début est modifiable
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        if (!this.pdpReIsActive){ // Vérifie l'évènement décocher la case
            if ( this.initialRoutingCode.pdpRe){
                if (this.initialRoutingCode.pdpRe.startDate.isAfter(this.todayDate) && !this.initialRoutingCode.pdpRe.startDate.isSame(this.todayDate)){ // Si une période est déjà enregistrée en base et que période future, vider les champs
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                } else if (this.initialRoutingCode.pdpRe.startDate.isBefore(this.todayDate) && this.initialRoutingCode.pdpRe.endDate && this.initialRoutingCode.pdpRe.endDate.isBefore(this.todayDate) && !this.initialRoutingCode.pdpRe.startDate.isSame(this.todayDate) && !this.initialRoutingCode.pdpRe.endDate.isSame(this.todayDate)){ // Si une période est déjà enregistrer en base et que période achevée afficher les valeurs sauvegardées en base
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                    this.routingCodeDto.pdpRe.startDate = this.initialRoutingCode.pdpRe.startDate;
                    this.routingCodeDto.pdpRe.endDate = this.initialRoutingCode.pdpRe.endDate;
                } else if ( this.initialRoutingCode.pdpRe.startDate.isBefore(this.todayDate) || this.initialRoutingCode.pdpRe.startDate.isSame(this.todayDate)){ // Si une période est déjà enregistrée en base et que période en cours, mettre la date du jour au niveau de la date de fin
                    this.clearEndPpdRe()
                    this.routingCodeDto.pdpRe.endDate = this.todayDate
                }
            } else { // Si aucune période n'est enregistrée en base, vider les champs
                this.clearStartPpdRe()
                this.clearEndPpdRe()
            }
            this.datePdpReChanged()
        }
    }
    minStartReDate(){
        if(this.showRoutingPdpRe)
            return this.isStartDatePdpReChanged() ? this.todayDate : ( this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.startDate.isBefore(this.todayDate) ? new Date(this.initialRoutingCode.pdpRe.startDate) : this.todayDate)
    }
    maxStartReDate(){
        if(this.showRoutingPdpRe)
            return this.routingCodeDto.pdpRe && this.routingCodeDto.pdpRe.endDate ? new Date(this.routingCodeDto.pdpRe.endDate ): null ;
    }
    minEndReDate(){
        if(this.isEndDatePdpReChanged() && this.routingCodeDto.pdpRe && this.routingCodeDto.pdpRe.startDate && moment(this.routingCodeDto.pdpRe.startDate).isAfter(this.todayDate)){
            return  new Date(this.routingCodeDto.pdpRe.startDate)
        }else if (!this.isEndDatePdpReChanged() && this.initialRoutingCode.pdpRe && this.initialRoutingCode.pdpRe.endDate && !this.initialRoutingCode.pdpRe.endDate.isAfter(this.todayDate)){
            return new Date(this.initialRoutingCode.pdpRe.endDate)
        }else{
            return this.todayDate
        }
    }
    clearStartPpdRe(){ // Vide le champs de date de début PDP en réception
        this.routingCodeDto.pdpRe.startDate = null;
        this.form.pdpStartDateRe.$setValidity('min',true)
        this.form.pdpStartDateRe.$setValidity('date',true)
        this.form.pdpStartDateRe.$setPristine()
    }
    clearEndPpdRe(){ // Vide le champs de date de fin PDP en réception
        this.routingCodeDto.pdpRe.endDate = null;
        this.form.pdpEndDateRe.$setValidity('min',true)
        this.form.pdpEndDateRe.$setValidity('date',true)
        this.form.pdpEndDateRe.$setPristine()
    }
    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut de réception PDP
     */
    canShowStartDatePdPReToasterError(){
        return (this.datePdpReChanged() && this.routingCodeDto.pdpRe.startDate.isBefore(this.todayDate) )
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de fin de réception PDP
     */
    canShowEndDatePdPReToasterError(){
        return (this.isEndDatePdpReChanged() || this.isStartDatePdpReChanged()) && this.routingCodeDto.pdpRe && this.routingCodeDto.pdpRe.endDate &&  this.routingCodeDto.pdpRe.endDate.isBefore(this.routingCodeDto.pdpRe.startDate) && !this.routingCodeDto.pdpRe.endDate.isSame(this.routingCodeDto.pdpRe.startDate);
    }
    setPdpBeforSave(){
        this.setPdpRe()
    }
    setPdpRe(){
            if(this.routingCodeDto.pdpRe){
                const startDate = this.form.pdpStartDateRe.$viewValue
                    ? this.formatDate(this.form.pdpStartDateRe.$viewValue)
                    : null;
                const endDate = this.form.pdpEndDateRe.$viewValue
                    ? this.formatDate(this.form.pdpEndDateRe.$viewValue)
                    : null;
                if(startDate){
                    this.routingCodeDto.pdpRe.startDate = startDate;
                    this.routingCodeDto.pdpRe.endDate = endDate
                   }
            }

    }

    prepareDataBeforeSave() {
        if( this.routingCodeDto.pdpRe && this.routingCodeDto.pdpRe.startDate) {
            this.routingCodeDto.pdpRe.startDate = this.formatDate(this.form.pdpStartDateRe.$viewValue).format(this.DATE_FORMAT_MASK);
            this.routingCodeDto.pdpRe.endDate = this.routingCodeDto.pdpRe.endDate  ? this.formatDate(this.form.pdpEndDateRe.$viewValue).format(this.DATE_FORMAT_MASK ) : null;
        }
    }
    // Envoi à la PPF
    isSentToPpf() {
        return this.initialRoutingCode.id && (this.initialRoutingCode.pdpRe != null && this.initialRoutingCode.pdpRe.sentToPpf == true);
    }
}

angular.module('app.principal').component('routingCode', {
    templateUrl: require('./modal-routing-code.html'),
    controller: routingCodeCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
});